enum Env {
  LOCAL = "LOCAL",
  UAT = "UAT",
  PROD = "PROD",
}

const ImageBaseUrl = {
  [Env.UAT]: "https://uat.myshubhlife.com",
  [Env.PROD]: "https://www.myshubhlife.com",
  [Env.LOCAL]: "https://uat.myshubhlife.com",
};

const gatewayHosts = {
  [Env.UAT]: "https://uat-gateway.datasignstech.com",
  [Env.PROD]: "https://gateway.datasignstech.com",
};

const env: Env = Env[(window as any).SL_ENV] || Env[`${process.env.REACT_APP_API_ENV}`];
export const imageBaseUrl = ImageBaseUrl[env];
export const gatewayUrl = gatewayHosts[env];